/* KOYO-CUSTOM: ada-nav-dismiss
   WCAG 1.4.13 (Content on Hover or Focus) — the header menus reveal their
   submenu when the pointer rests on a top-level item, and there was no way to
   put that panel away without moving the pointer. The theme marks an open item
   with a `hover` class, but the panel is also held open by the CSS `:hover`
   state, so dropping the class is not enough while the pointer stays where it
   is. Escape therefore also sets a flag on the document that hides the panel,
   and the flag is dropped again the moment the visitor moves the pointer,
   presses a key or moves focus — so the menu behaves exactly as before from
   the next interaction onward. If focus is sitting inside the panel it goes
   back to the item that opened it. */
(function () {
  'use strict';

  if (window.__koyoA11yNav) return;
  window.__koyoA11yNav = true;

  var NAV_SELECTOR = '#nav';
  var OPEN_CLASS = 'hover';

  function openItems() {
    var nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return [];
    return Array.prototype.slice.call(nav.querySelectorAll('li.' + OPEN_CLASS));
  }

  function topLevelLink(item) {
    for (var i = 0; i < item.children.length; i++) {
      if (item.children[i].tagName === 'A') return item.children[i];
    }
    return null;
  }

  var DISMISSED_ATTR = 'data-koyo-nav-dismissed';

  function release() {
    document.documentElement.removeAttribute(DISMISSED_ATTR);
  }

  function submenuOnScreen() {
    var nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return false;
    var lists = nav.querySelectorAll('li > ul');
    for (var i = 0; i < lists.length; i++) {
      var style = window.getComputedStyle(lists[i]);
      if (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        lists[i].getBoundingClientRect().height > 20
      ) {
        return true;
      }
    }
    return false;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    if (!submenuOnScreen()) return;

    var items = openItems();
    var active = document.activeElement;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (active && item.contains(active)) {
        var link = topLevelLink(item);
        if (link) link.focus();
      }
      item.classList.remove(OPEN_CLASS);
    }

    document.documentElement.setAttribute(DISMISSED_ATTR, '');
  });

  // Any further interaction hands the menu back to the theme.
  document.addEventListener('pointermove', release, true);
  document.addEventListener('pointerdown', release, true);
  document.addEventListener('focusin', release, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) release();
  }, true);
})();
